import { EntityType } from 'app/agriculture/models/Entities';
import { useSelection } from 'app/agriculture/ContextMenu/hooks/useSelection/useSelection';
import { getAssetIconConfig } from 'app/agriculture/icons/utils/map-icon-utils/getAssetIconConfig';
import {
    createBillboardIconDataUri,
    createBillboardWithoutIconDataUri,
} from 'app/agriculture/icons/utils/map-icon-utils/createBillboardIconDataUri';
import { CesiumBillboard } from 'app/agriculture/FarmMain/MapRenderer/components/CesiumBillboard';
import { createIcon } from 'app/agriculture/hooks/useMapRender/mapRenderUtils';
import { Position } from 'app/agriculture/queries/types/geometry/Position';

export function Billboard({
    id,
    type,
    coordinates,
}: {
    id: string;
    type: EntityType;
    coordinates: Position;
}) {
    const { isSelected } = useSelection();
    const { icon, options } = getAssetIconConfig(type);
    const image = !icon
        ? createBillboardWithoutIconDataUri(options)
        : createBillboardIconDataUri(icon, options);

    return (
        <CesiumBillboard
            billboardOptions={createIcon({
                id,
                image,
                coordinates,
                isPin: options?.billboardType === 'pin' || false,
                isSelected: isSelected(id),
            })}
        />
    );
}
